// src/components/Loading/CustomLoading.tsx

import { useTranslation } from "react-i18next";
import "./CustomLoading.css";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { renderIcon } from "../../utils/ultis";

export default function CustomLoading()
{
  const { t } = useTranslation();

  const commonSytem = useSelector((state: RootState) => state.appCommonSlice.commonSystem)
  const colorConfig = useSelector(
    (state: RootState) => state.appCommonSlice.colorConfig
  );

  const theme = useSelector((state: RootState) => state.appCommonSlice.theme);
  return (
    <div className="custom-loading-overlay" style={{

      minHeight: "100vh",
    }}>
      <div className="custom-loading-content">
        <center>
          {
            commonSytem?.logo ? <>{renderIcon(
              commonSytem?.logo?.type,
              commonSytem?.logo,
              "!h-[140px] !w-[172px] !min-w-[172px]"
            )}</> : <><img src="./default-logo.png" className="!h-[140px] !w-[172px] !min-w-[172px]" /></>
          }

        </center>

        <h1
          className="custom-loading-title mt-4 text-[var(--color-main-text)]"

        >
          {commonSytem?.titleApp ?? 'VMRS'}
        </h1>
        <div className="custom-loading-bar">
          <div className="custom-loading-progress"></div>
        </div>
      </div>
    </div>
  );
}
